import React from "react";

const Services = () => {
  return (
    <>
      <div className="row gx-0 pt-md-5 px-md-5 px-2 text-center" id="targetService">
        <h1 className="pb-3 pb-md-0"> Services </h1>
        <div className="col-12">
          <div className="col-md-8 m-auto">
            <p className="mx-md-5 px-md-5 px-2 py-3">
              <small>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Accusantium ratione inventore quod et debitis maiores quaerat
                suscipit minima. Dolor quidem velit.
              </small>
            </p>
          </div>
        </div>
        <div className="col-md-3 col-6 px-md-4 pe-1 py-md-3">
          <div
            className="serviceCard"
            style={{
              backgroundColor: "white",
              borderRadius: "15px",
              boxShadow: "0px 10px 15px -3px rgba(0,0,0,0.1)",
            }}
          >
            <div className="p-2">
              <img
                src="images/service1.png"
                className="img-fluid"
                alt=""
                style={{ borderRadius: "15px" }}
              />
            </div>
            <h5 className="fw-normal mt-2"> Customize with ease </h5>
            <p className="text-muted p-3" style={{ textAlign: "justify" }}>
              <small>
                The value of design has been discussed a lot in the recent
                years. It's recognised that design.
              </small>
            </p>
          </div>
        </div>
        <div className="col-md-3 col-6 px-md-4 ps-1 py-md-3">
          <div
            className="serviceCard"
            style={{
              backgroundColor: "white",
              borderRadius: "15px",
              boxShadow: "0px 10px 15px -3px rgba(0,0,0,0.1)",
            }}
          >
            <div className="p-2">
              <img
                src="images/service2.png"
                className="img-fluid"
                alt=""
                style={{ borderRadius: "15px" }}
              />
            </div>
            <h5 className="fw-normal mt-2"> Best UI, UX Integration </h5>
            <p className="text-muted p-3" style={{ textAlign: "justify" }}>
              <small>
                The value of design has been discussed a lot in the recent
                years. It's recognised that design.
              </small>
            </p>
          </div>
        </div>
        <div className="col-md-3 col-6 px-md-4 pe-1 py-md-3">
          <div
            className="serviceCard"
            style={{
              backgroundColor: "white",
              borderRadius: "15px",
              boxShadow: "0px 10px 15px -3px rgba(0,0,0,0.1)",
            }}
          >
            <div className="p-2">
              <img
                src="images/service5.png"
                className="img-fluid"
                alt=""
                style={{ borderRadius: "15px" }}
              />
            </div>
            <h5 className="fw-normal mt-2"> Fully Responsive </h5>
            <p className="text-muted p-3" style={{ textAlign: "justify" }}>
              <small>
                The value of design has been discussed a lot in the recent
                years. It's recognised that design.
              </small>
            </p>
          </div>
        </div>
        <div className="col-md-3 col-6 px-md-4 ps-1 py-md-3">
          <div
            className="serviceCard"
            style={{
              backgroundColor: "white",
              borderRadius: "15px",
              boxShadow: "0px 10px 15px -3px rgba(0,0,0,0.1)",
            }}
          >
            <div className="p-2">
              <img
                src="images/service4.png"
                className="img-fluid"
                alt=""
                style={{ borderRadius: "15px" }}
              />
            </div>
            <h5 className="fw-normal mt-2"> Privacy Of Data </h5>
            <p className="text-muted p-3" style={{ textAlign: "justify" }}>
              <small>
                The value of design has been discussed a lot in the recent
                years. It's recognised that design.
              </small>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Services;
